import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { CoreTextField } from 'src/components/core'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@material-ui/core'
import styles from './styles'
import { useSelector } from 'react-redux'
const WidgetForm = ({
  classes,
  config,
  onConfigChange,
  showPosition = true,
}) => {
  const handleChange = (field, fieldValue) => {
    onConfigChange({ ...config, [field]: fieldValue })
  }
  const collection = useSelector(state => state.collection.collection)
  return (
    <div className={classes.root}>
      <CoreTextField
        label="Title"
        placeholder="Widget title"
        fullWidth
        value={config?.title || collection?.name || ''}
        onChange={e => handleChange('title', e.target.value)}
      />
      <div className={classes.twoTextfield}>
        <FormControl variant="outlined" className={classes.mobileSelect}>
          <InputLabel>Theme</InputLabel>
          <Select
            label="Theme"
            className={classes.select}
            value={config?.theme || 'light'}
            onChange={e => handleChange('theme', e.target.value)}
          >
            <MenuItem value="light">
              <div className={classes.menuItem}>
                <Typography>Light</Typography>
              </div>
            </MenuItem>
            <MenuItem value="dark">
              <div className={classes.menuItem}>
                <Typography>Dark</Typography>
              </div>
            </MenuItem>
          </Select>
        </FormControl>
        {config?.modalMaxWidth && (
          <CoreTextField
            label="Max Width (px)"
            placeholder="800"
            fullWidth
            value={config.modalMaxWidth}
            onChange={e => handleChange('modalMaxWidth', e.target.value)}
          />
        )}
      </div>

      <div className={classes.twoTextfield}>
        {showPosition && (
          <FormControl variant="outlined" className={classes.mobileSelect}>
            <InputLabel>Position</InputLabel>
            <Select
              label="Position"
              className={classes.select}
              value={config?.position || 'left'}
              onChange={e => handleChange('position', e.target.value)}
            >
              <MenuItem value="left">
                <div className={classes.menuItem}>
                  <Typography>Left</Typography>
                </div>
              </MenuItem>
              <MenuItem value="right">
                <div className={classes.menuItem}>
                  <Typography>Right</Typography>
                </div>
              </MenuItem>
            </Select>
          </FormControl>
        )}
        {config.widget === 'sidebar' && (
          <CoreTextField
            label="Width (px)"
            placeholder="400"
            fullWidth
            value={config?.width || ''}
            onChange={e => handleChange('width', e.target.value)}
          />
        )}
      </div>

      {config?.directLinkText && (
        <CoreTextField
          label="Link Text"
          placeholder="Open Documentation"
          fullWidth
          value={config.directLinkText}
          onChange={e => handleChange('directLinkText', e.target.value)}
        />
      )}
    </div>
  )
}

export default withStyles(styles)(WidgetForm)
